import React, { useId } from "react";
import TemplateCreator from "./TemplateCreator";
import { templatesData } from "./data";
import { Grid } from "@mui/material";
import { Item } from "./styledComponent";

const TemplateCreatorWrapper = ({ organizationIdentifier }) => {
  const id = useId();
  return (
    <>
      <Grid container spacing={2} sx={{ paddingBlock: 2 }}>
        <Grid xs={12} item>
          <Item elevation={0}>
            <h6 className="add-edit-patient-sub-header">Update Templates</h6>
          </Item>
        </Grid>
        {templatesData.map((item) => (
          <Grid xs={12} sm={6} lg={3} item key={id + item?.title}>
            <Item elevation={0}>
              <TemplateCreator
                organizationIdentifier={organizationIdentifier}
                title={item?.title}
                type={item?.type}
                templateRequired={item?.templateRequired}
              />
            </Item>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default TemplateCreatorWrapper;
